import { Validator } from './validator.type';

export function createIsNumberGreaterOrEqualValidator<
  TFormData,
  TKey extends keyof TFormData,
>(max: number): Validator<TFormData, TKey> {
  return ({ value }) => typeof value !== 'number' || max <= value;
}
